module.exports = __webpack_public_path__ + "static/p2040025-fe0cb3d78231a66376eb9faeb6c1f006.jpg";